export default {
  tool: {
    label: '创意工具箱',
    playable: {
      name: '可玩模板',
      describe: '利用模板换肤制作可玩素材',
    },
    normal: {
      name: '自由编辑器',
      describe: '像做PPT一样轻松制作可玩素材',
    },
    iv: {
      name: '视频转可玩',
      describe: '利用视频片段制作可玩素材',
    },
    videoTemplate: {
      name: '视频布局模板',
      describe: '批量生成多比例、多语言视频',
    },
    videoEditor: {
      name: '视频编辑器',
      describe: '视频广告在线编辑',
    },
    aiBanner: {
      name: '链接生图',
      describe: '基于产品链接生成图片创意',
    },
    actions: {
      demoProject: 'Demo项目',
    },
    PPT: {
      name: '图片转视频',
      describe: '利用图片素材快速制作视频广告',
    },
    avatarToVideo: {
      name: '数字人视频',
      describe: '快速生成带有数字人的视频广告',
    },
    recommendTool: {
      name: '推荐工具',
    },
    videoTool: {
      name: '视频工具',
    },
    imageTextTool: {
      name: '图片工具',
    },
    playableTool: {
      name: '可玩工具',
    },
    ai: {
      name: 'AI视频',
      describe: '用于消除字幕、替换 icon、AI 配音等。',
    },
    banner: {
      name: '链接生图（内测）',
      describe: '基于推广链接智能生成广告图片创意。',
    },
    commonTemplate: {
      describe: '可批量裂变成多个比例、多个语言版本。',
    },
  },
  playable: {
    label: {
      name: '可玩模板',
    },
    gameplay: {
      support: '支持快捷排版',
      nosupport: '暂不支持快捷排版',
    },
    wxgame: {
      support: '支持小游戏原生试玩',
    },
    describe: '丰富的模板，可根据创意使用场景及需求进行自主挑选。',
    public: '公共',
    collection: '我的收藏',
    template: '我的模板',
  },
  template: '模板',
  video: {
    describe:
      '根据模板快速完成视频素材批量制作，支持素材组合裂变、尺寸裂变、语言裂变。',
    filter: {
      search: '搜索',
      creative: '创意模板',
      multiScale: '布局模板',
      replaceVideo: '填充视频数',
      replaceImage: '填充图片数',
      replaceText: '填充文本数',
      videoNum: '视频数量',
      imageNum: '图片数量',
      textNum: '文本数量',
      number: '个',
      mainVideo: '主视频',
      mainDirection: '主视频方向',
    },
    table: {
      unMute: '解除静音',
      mute: '静音',
      videoClips: '视频编辑器',
      quickReplace: '快速替换',
      useTemplate: '使用模板',
      rules: '暂不支持替换素材',
      recommend: '更多模板推荐',
      noRecommend: '暂无推荐模板',
      originality: '创意',
      multScale: '布局',
      end: '您已到达末尾',
      proportionNoEmpty: '比例不能为空',
    },
    aiBannerDialog: {
      create: '新建-链接生图',
    },
    replaceDialog: {
      create: '新建-布局模板',
      exportScale: '导出比例',
      addLanguage: '新增语言',
      languagePlace: '请选择要裂变的语言',
    },
  },
  iv: {
    noProject: '暂无视频转可玩项目',
    createProject: '创建项目',
  },
}
